export default __webpack_public_path__ + "static/media/buffer.c7d9f081.gif";